export const educationData = [
    {
        id: 1,
        institution: 'PMAS Arid Agriculture University Rawalpindi',
        course: 'Bachelor of Software Engineering',
        startYear: 'October 2022',
        endYear: 'May 2026'
    },
    {
        id: 2,
        institution: 'PMAS Arid Agriculture University Rawalpindi',
        course: 'Web Developnment(Mern Stack) Course',
        startYear: '2023',
        endYear: '2023'
    },
    {
        id: 3,
        institution: 'PMAS Arid Agriculture University Rawalpindi',
        course: 'Graphic Designing(UI/UX) Course',
        startYear: '2022',
        endYear: '2022'
    },
    {
        id: 4,
        institution: 'Buraq Institute of Science and Technology',
        course: 'Basis Web Developnment Course',
        startYear: '2021',
        endYear: '2022'
    },
]